export enum Ethnicity {
    Hispanic = 'H',
    NotHispanic = 'N',
    NoAnswer = 'X',
}
